import React from 'react';
import { useNavigate } from 'react-router-dom';

import { useDisclosure, useToast } from '@chakra-ui/react';
// import { buscaTodosDados } from '../Services/Firebase/BuscaDados';
// import { BuscaTodasApostas } from '../Services/Firebase/Aposta';
// import { BuscaTodosCliente } from '../Services/Firebase/Cliente';
// import { BuscaultimoJogo } from '../Services/Firebase/jogo';
// import { BuscaTodosNumeros } from '../Services/Firebase/numerosJogo';
// import { BuscaUltimoSorteio } from '../Services/Firebase/ultimoSorteio';
// import { BuscaTodosCampeoes } from '../Services/Firebase/Campeoes';
import { BASEURL } from '../styles/utils';
import Axios from 'axios';

export const UserContext = React.createContext();

export const UserDataContext = ({ children }) => {
  const navigate = useNavigate();
  const toast = useToast();
  const [rankingData, setrankingData] = React.useState([]);

  const [atualiza, setatualiza] = React.useState([]);
  const [loadingApostas, setloadingApostas] = React.useState(false);
  const [loadingGertal, setloadingGertal] = React.useState(false);
  const [dataApostaComp, setdataApostaComp] = React.useState([]);
  const [dataUltimoJogo, setdataUltimoJogo] = React.useState([]);
  const [dataNumeroSorteioComp, setdataNumeroSorteioComp] = React.useState([]);
  const [dataNumeroSorteioIDComp, setdataNumeroSorteioIDComp] = React.useState([]);
  const [dataUltimoSorteioComp, setdataUltimoSorteioComp] = React.useState();
  const [JogosRanking, setJogosRanking] = React.useState([]);

  const [numerosJogosRanking, setnumerosJogosRanking] = React.useState([]);
  const [ApostasJogosRanking, setApostasJogosRanking] = React.useState([]);

  const [IsLogin, setIsLogin] = React.useState(false);

  const [jogosSelect, setjogosSelect] = React.useState([]);

  const [dataApostasPagas, setdataApostasPagas] = React.useState([]);
  const [dataApostasNaopagas, setdataApostasNaopagas] = React.useState([]);
  const [numerosJaSortados, setnumerosJaSortados] = React.useState(null);
  // const [numerosJaSortadosRank, setnumerosJaSortadosRank] = React.useState(null);
  const [jogoAtivo, setjogoAtivo] = React.useState(false);
  

  const [dezAcertosData, setdezAcertosData] = React.useState([]);

  const [pago6, setpago6] = React.useState(null);
  const [pago7, setpago7] = React.useState(null);
  const [pago8, setpago8] = React.useState(null);
  const [pago9, setpago9] = React.useState(null);

  React.useEffect(() => {
    async function syncAllData() {
      setloadingGertal(true);
      try {
        await Promise.all([
          buscaJogoAberto(),
          buscaJogos(),
          buscaApostasGeral(),
          buscaCampeoesHistorico()
        ]);
      } catch (error) {
        console.error("Erro na sincronização de dados:", error);
      } finally {
        setloadingGertal(false);
      }
    }

    syncAllData();
    console.log('Dados sincronizados com sucesso.');
  }, [atualiza]);

  async function buscaApostasGeral() {
    try {
      const response = await Axios.get(`${BASEURL}/apostas/1`);
      if (response?.data?.data?.length > 0) {
        setdataApostaComp(response.data.data);
      }
    } catch (error) {
      console.error("Erro ao buscar apostas gerais:", error);
    }
  }

  async function buscaJogos() {
    try {
      const response = await Axios.get(`${BASEURL}/jogos/1`);
      if (response?.data?.data) {
        setJogosRanking(response.data.data);
        const list = response.data.data.sort((a,b) => a.idjogos - b.idjogos);
        const aux = list
          .filter(item => item?.idjogos > 6 && item?.idjogos !== 9)
          .map((item, index) => ({
            id: item?.idjogos,
            value: item?.idjogos,
            label: 'BOLÃO: ' + (7 + index), // Mantendo lógica de rotulagem anterior simplificada
          }));
        setjogosSelect(aux);
      }
    } catch (error) {
      console.error("Erro ao buscar lista de jogos:", error);
    }
  }

  async function buscaJogoAberto() {
    try {
      const respUltimo = await Axios.get(`${BASEURL}/jogos/ultimo/1`);
      const ultimoJogo = respUltimo?.data?.data?.[0];

      if (ultimoJogo) {
        setdataUltimoJogo(ultimoJogo);
        setpago6(ultimoJogo.pago6);
        setpago7(ultimoJogo.pago7);
        setpago8(ultimoJogo.pago8);
        setpago9(ultimoJogo.pago9);

        const jogoId = ultimoJogo.idjogos;

        // Disparar buscas dependentes do jogo atual EM PARALELO
        await Promise.all([
          fetchApostasDoJogo(jogoId),
          fetchNumerosDoJogo(jogoId)
        ]);
      }
    } catch (error) {
      console.error("Erro ao buscar jogo aberto:", error);
    }
  }

  async function fetchApostasDoJogo(id) {
    setloadingApostas(true);
    try {
      // Disparamos as buscas específicas em paralelo para máxima performance
      const [respPagas, respNaoPagas, respRanking] = await Promise.all([
        Axios.get(`${BASEURL}/apostas/jogo/pago/${id}`),
        Axios.get(`${BASEURL}/apostas/jogo/naopago/${id}`),
        Axios.get(`${BASEURL}/apostas/jogo/${id}`)
      ]);

      const pagas = respPagas?.data?.data || [];
      const naoPagas = respNaoPagas?.data?.data || [];
      const ranking = respRanking?.data?.data || [];

      setdataApostasPagas(pagas);
      setdataApostasNaopagas(naoPagas);
      setApostasJogosRanking(ranking);

    } catch (error) {
      console.error("Erro ao buscar apostas do jogo:", error);
    } finally {
      setloadingApostas(false);
    }
  }

  async function fetchNumerosDoJogo(id) {
    try {
      const resp = await Axios.get(`${BASEURL}/numerosJogos/${id}`);
      const numeros = resp?.data?.data || [];

      // Atualiza múltiplos estados que dependiam dessa mesma chamada
      setjogoAtivo(numeros.length > 0);
      setdataNumeroSorteioComp(numeros);
      guardaNumerosSortados(numeros); // Alimenta numerosJaSortados
      guardaNumerosSortadosRank(numeros); // Alimenta numerosJogosRanking
    } catch (error) {
      console.error("Erro ao buscar números do jogo:", error);
    }
  }

  // Mantendo versões simplificadas das funções caso sejam chamadas externamente por ID diferente do "último"
  async function numerosPorJogo(item) {
    await fetchNumerosDoJogo(item);
  }

  async function ApostasPorJogo(item) {
    await fetchApostasDoJogo(item);
  }

  async function buscaNumerosSorteioDados(id) {
    if (id) await fetchNumerosDoJogo(id);
  }

  async function buscaApostaPagas(id) {
    // Redirecionado para o fetch inteligente
    await fetchApostasDoJogo(id);
  }

  async function buscaApostaNaoPagas(id) {
    // Redirecionado para o fetch inteligente
    await fetchApostasDoJogo(id);
  }

  function guardaNumerosSortados(valor) {
    const aux = [];
    if (valor?.length > 0) {
      valor.forEach(element => {
        if (element?.num1 && !aux.includes(Number(element.num1))) aux.push(Number(element.num1));
        if (element?.num2 && !aux.includes(Number(element.num2))) aux.push(Number(element.num2));
        if (element?.num3 && !aux.includes(Number(element.num3))) aux.push(Number(element.num3));
        if (element?.num4 && !aux.includes(Number(element.num4))) aux.push(Number(element.num4));
        if (element?.num5 && !aux.includes(Number(element.num5))) aux.push(Number(element.num5));
        if (element?.num6 && !aux.includes(Number(element.num6))) aux.push(Number(element.num6));
        // Adicionando até o num10 se existir, pois alguns jogos parecem usar mais
        if (element?.num7 && !aux.includes(Number(element.num7))) aux.push(Number(element.num7));
        if (element?.num8 && !aux.includes(Number(element.num8))) aux.push(Number(element.num8));
        if (element?.num9 && !aux.includes(Number(element.num9))) aux.push(Number(element.num9));
        if (element?.num10 && !aux.includes(Number(element.num10))) aux.push(Number(element.num10));
      });
    }
    setnumerosJaSortados(aux);
  }

  function guardaNumerosSortadosRank(valor) {
    const aux = [];
    if (valor?.length > 0) {
      valor.forEach(element => {
        if (element?.num1 && !aux.includes(Number(element.num1))) aux.push(Number(element.num1));
        if (element?.num2 && !aux.includes(Number(element.num2))) aux.push(Number(element.num2));
        if (element?.num3 && !aux.includes(Number(element.num3))) aux.push(Number(element.num3));
        if (element?.num4 && !aux.includes(Number(element.num4))) aux.push(Number(element.num4));
        if (element?.num5 && !aux.includes(Number(element.num5))) aux.push(Number(element.num5));
        if (element?.num6 && !aux.includes(Number(element.num6))) aux.push(Number(element.num6));
      });
    }
    setnumerosJogosRanking(aux);
  }


  // async function buscaCampeoesDados() {
  //   await BuscaTodosCampeoes()
  //     .then((item) => {
  //       setdezAcertosData(item)
  //       // setTotalPRemio(item[3]?.data.data)
  //     })
  // }

  async function buscaCampeoesHistorico() {
    try {
      const response = await Axios.get(`${BASEURL}/campeoes/todos/1`);
      if (response?.data?.data) {
        const options = response.data.data.map((item) => ({
          value: item?.num_sorteio,
          label: `Bolão Nº ${item?.num_sorteio}`,
        }));
        setdezAcertosData(options); // Usando dezAcertosData para a lista de campeões históricos
      }
    } catch (error) {
      console.error("Erro ao buscar histórico de campeões:", error);
    }
  }

  return (
    <UserContext.Provider
      value={{
        atualiza,
        setatualiza,
        dataApostaComp,
        dataUltimoJogo,
        dataNumeroSorteioComp,
        dataUltimoSorteioComp,
        dataApostasPagas,
        dataApostasNaopagas,
        numerosJaSortados,
        jogoAtivo,
        dezAcertosData,
        loadingApostas, 
        setloadingApostas,
        setdataUltimoSorteioComp,
        setdezAcertosData,
        dataNumeroSorteioIDComp,
        buscaJogos,
        JogosRanking, 
        setJogosRanking,
        jogosSelect,
        numerosPorJogo,
        ApostasPorJogo,
        numerosJogosRanking,
        ApostasJogosRanking,
        rankingData,
        setrankingData,
        IsLogin, 
        setIsLogin,
        loadingGertal, 
        setloadingGertal,
        pago6,
        pago7,
        pago8,
        pago9
        // abaixo devem ficar as que ja foram usadas em algum lugar
      }}
    >
      {children}
    </UserContext.Provider>
  );
};
